import { GroupsApi, UserDto } from '../../../api-client';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ErrorResponse } from '../../../common/types/errorRespose';

export const useGetGroupUsers = (
  groupsApi: GroupsApi,
  groupId: string,
  options?: Omit<
    UseQueryOptions<UserDto[], ErrorResponse>,
    "queryKey" | "queryFn"
    >,
): UseQueryResult<UserDto[]> => {
  const tenantId = localStorage.getItem('tenantId') as string;

  return useQuery(
    [`group-${groupId}-users`],
    async () => groupsApi.getUsersInGroup(tenantId, groupId).then(({ data }) => data),
    options,
  );
};
